@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notifications
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.models.MessageRecipients
import com.narbase.letsgo.web.models.OperatingSystem

@Suppress("NON_EXPORTABLE_TYPE")
data class NotificationDto(
    val id: KmmLong?,
    val title: String,
    val body: String?,
    val imageUrl: String?,
    val createdOn: DateTimeDto,
    @Suppress("NON_EXPORTABLE_TYPE") val recipients: DtoName<MessageRecipients>?,
    val driverId: KmmLong?,
    val passengerId: KmmLong?,
    val driverProfileGroupId: Int?,
    val passengerProfileGroupId: Int?,
    val carTypeId: Int?,
    val passengerZoneId: Int?,
    @Suppress("NON_EXPORTABLE_TYPE") val passengerOs: DtoName<OperatingSystem>?
)
